<ng-container *kienePermission="[9380]">
    <div class="one-row" style="margin-top: 24px">
        <h2>Belege und Kosten (nur Admins)</h2>
        <span class="spacer"></span>
        <button
            *kienePermission="[1247]"
            mat-raised-button
            color="accent"
            (click)="downloadAbgabebelegePositionenPdf()"
            style="margin-right: 12px"
            [disabled]="!statistiken?.anzahl_abgabebelege"
        >
            <mat-icon>download</mat-icon>
            Alle Abgabebelege
        </button>
        <button
            *kienePermission="[1399]"
            mat-raised-button
            color="accent"
            (click)="downloadBefundPositionenPdf()"
            [disabled]="!statistiken?.anzahl_befunde"
        >
            <mat-icon>download</mat-icon>
            Alle Befunde
        </button>
    </div>
    <table class="phito-table" style="margin: 24px 0">
        <thead>
            <tr>
                <th>Anzahl Tiere</th>
                <th>Kosten Abgabebelege</th>
                <th>Kosten Befunde</th>
                <th>Gesamtkosten</th>
                <th>Kosten pro Tier</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>{{ gruppe?.anzahl_tiere_gesamt }}</td>
                <td>{{ statistiken?.kosten_abgabebelege | number: "1.2-2" }}€</td>
                <td>{{ statistiken?.kosten_befunde | number: "1.2-2" }}€</td>
                <td>{{ statistiken?.kosten_abgabebelege + statistiken?.kosten_befunde | number: "1.2-2" }}€</td>
                <td
                    >{{
                        (statistiken?.kosten_abgabebelege + statistiken?.kosten_befunde) / gruppe?.anzahl_tiere_gesamt
                            | number: "1.2-2"
                    }}€
                </td>
            </tr>
        </tbody>
    </table>

    <kiene-kiene-table *kienePermission="[9187]" [tableDescriptor]="tableDescriptorAbgabebelege"> </kiene-kiene-table>

    <kiene-kiene-table *kienePermission="[9188]" [tableDescriptor]="tableDescriptorBefunde"> </kiene-kiene-table>
</ng-container>
